import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

const PersonalCTA = () => (
  <section className="py-32 md:py-48 bg-[#2E1B16] text-[#FAF7F2]" data-testid="personal-cta" aria-labelledby="personal-cta-heading">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <h2 id="personal-cta-heading" className="font-display uppercase text-[2.6rem] sm:text-6xl lg:text-[6.5rem] tracking-tight leading-[0.9] max-w-5xl">
          Your business already has a story.
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="mt-6 font-accent text-4xl sm:text-5xl lg:text-7xl text-[#38BDF8] leading-none">We just need to find it.</p>
      </Reveal>
      <Reveal delay={0.15}>
        <div className="mt-16 md:mt-20 grid md:grid-cols-[1fr_auto] gap-10 items-end">
          <p className="text-lg md:text-xl text-[#FAF7F2]/65 leading-relaxed max-w-md">
            Tell us what you're building, where you're trying to take it and what's getting in the way.
          </p>
          <button onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })} data-testid="personal-cta-button"
            className="group inline-flex items-center gap-2 rounded-full bg-[#FAF7F2] text-[#2E1B16] font-semibold px-8 py-4 hover:bg-[#38BDF8] transition-colors duration-300">
            Tell us about your business <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
          </button>
        </div>
      </Reveal>
    </div>
  </section>
);

export default PersonalCTA;
